<template>
  <div class="panic" ref="panic">
    <div v-for="(line, i) in lines" :key="i">
      <div class="line break" v-if="line === '<break>'"></div>
      <div class="line" v-else>
        {{ line }}
      </div>
      <br>
    </div>
    <div v-if="showLinks">
      <div class="photo">
        <img src="/michaelbates.jpg">
      </div>
      <br>
      <div class="line">
        Michael Bates - Software Developer from Melbourne, Australia
      </div>
      <br>
      <div class="line break"></div>
      <br>
      <div class="line">
        Find me on:
        <a class="email" href="mailto:hello@michaelbat.com" target="_blank">Email</a>
      </div>
    </div>
  </div>
</template>

<script>
import {sleep} from '@/utils'

const LINES = [
  "Anonymous UUID:       55E7769C-B596-6BC8-7C49-B7292D9F3A27",
  "<break>",
  "11:08:37 AM",
  "<break>",
  "*** Kernel Panic ***",
  "panic(cpu 0 caller 0xffffff801ed88c2d): Kernel trap at 0xffffff803209c6d0, type 14=page fault, registers:",
  "CR0: 0x000000008001003b, CR2: 0xffffff803209c6d0",
  "RAX: 0x0000000000000000, RBX: 0x0000000000000006",
  "RSP: 0xffffff912bab3ed0, RBP: 0x0000000000000005",
  "R8:  0xffffff80316c4000, R9:  0x0000000000000003",
  "R12: 0xffffff80333ed420, R13: 0x00007fff6dc47eb8",
  "RFL: 0x0000000000010282, RIP: 0xffffff803209c6d0",
  "Fault CR2: 0xffffff803209c6d0, Fault CPU: 0x0 Kernel NX fault, PL: 0, VF: 2",
  "<break>",
  "Unaligned frame",
  "Backtrace terminated-invalid frame pointer 0x5",
  "BSD process name corresponding to current thread: humand",
  "<break>",
  "<break>"
]

export default {
  data () {
    return {
      lines: [],
      showLinks: false
    }
  },
  methods: {
    ready () {
      this.run()
    },
    async run () {
      for(const line of LINES) {
        this.lines.push(line)
        this.scroll()
        await sleep(65)
      }
      this.showLinks = true
      this.scroll()
    },
    scroll () {
      this.$nextTick(() => {
        this.$refs.panic.scrollTop = this.$refs.panic.scrollHeight
      })
    }
  },
  mounted () {
    this.ready()
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/mixins";

.panic {
  position: absolute;
  left: 0;
  top: 0;
  padding-top: 1px;
  padding-bottom: 30px;
  width: 100%;
  height: 100%;
  overflow: auto;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.3);

  .line {
    background-color: black;
    font-family: Courier, monospace;
    font-size: 14px;
    color: white;
    display: inline;
    padding: 4px;
    @include css3-prefix(box-decoration-break, clone);

    &.break {
      display: block;
      padding: 0;
      background-color: transparent;
    }

    a {
      color: white;
      text-decoration: underline;
      margin-right: 10px;

      &:last-of-type {
        margin-right: 2px;
      }

      &.email {
        color: #FFE896;
      }
    }
  }

  .photo {
    display: inline-block;
    background-color: black;
    padding: 5px;

    img {
      width: 120px;
      height: auto;
    }
  }
}
</style>
